import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_70, COLOR_PURPLE } from 'styles/variables/colors';
import { FONT_FAMILY } from 'styles/variables/typography';

export const useStyles = makeStyles((theme) => ({
  groupContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(1),

    [theme.breakpoints.down('md')]: {
      maxWidth: 320,
      flexWrap: 'wrap',
      margin: '0 auto',
    },
  },
  groupContainerCondensed: {
    justifyContent: 'start',
  },
  option: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    height: 48,
    minWidth: 70,
    padding: '14.5px 11.5px',
    borderRadius: 6,
    border: '1px solid #616161',
    backgroundColor: '#fff',

    [theme.breakpoints.down('md')]: {
      minWidth: 48,
    },

    '& input': {
      display: 'none',
    },

    '& span': {
      textAlign: 'center',
      fontWeight: 700,
      fontFamily: FONT_FAMILY,
      color: COLOR_GRAY_70,
    },
  },
  optionCondensed: {
    height: 31,
  },
  optionActive: {
    borderColor: COLOR_PURPLE,
    backgroundColor: COLOR_PURPLE,

    '& span': {
      color: '#fff',
    },
  },
}));
